<template>
    <div :style="{ boxShadow: needBoxShadow ? '0px 1px 4px rgba(16, 16, 20, 0.15)' : '' }" style="display: flex; align-items: center; gap: 15px; padding:17px 20px; border-radius: 12px;">
        <div style="display: flex; justify-content: center; align-items: center;">
            <img style="width: 62px;" :src="require('@/assets/img/pay_card.png')" alt="">
        </div>
        <div style="font-weight: 500;">
            <div style="font-size: 14px; line-height: 24px;">{{ bank_name }} ({{ card_number }})</div>
            <div style="font-weight: 400; font-size: 14px; line-height: 24px; color: #808080;">{{ date_str }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CreditCard',
    computed: {
        date_str() {
            if (this.expiry_date) {
                return this.expiry_date.substr(0, 2) + '/' + '20' + this.expiry_date.substr(3, 2);
            } else {
                return '';
            }
        }
    },
    props: {
        bank_name: {
            type: String,
            default: '',
        },
        expiry_date: {
            type: String,
            default: '',
        },
        card_number: {
            type: String,
            default: '',
        },
        needBoxShadow: {
            type: Boolean,
            default: true
        }

    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}
</style>